import Table, { TableProps } from 'antd/lib/table'
import styles from './Table.module.less'
import EmptyIcon from '../../../assets/icons/empty-icon.svg?react'
import ConfigProvider from 'antd/lib/config-provider'
import Icon from '@ant-design/icons/lib/components/Icon'

export type CommonDataTableType = {
    key: string
}

export interface ITableCompProps<T> extends TableProps<T> {
    emptyIconText?: string
    className?: string
}

const TableComp = <T extends CommonDataTableType>(props: ITableCompProps<T>) => {
    return (
        <div className={styles['table-parent']} data-testid="table-wrapper">
            <ConfigProvider
                renderEmpty={() => (
                    <div className={styles['empty']}>
                        <Icon className={styles['empty-icon']} component={EmptyIcon} />
                        <span className={styles['empty-text']}>{props.emptyIconText}</span>
                    </div>
                )}
                theme={{
                    components: {
                        Table: {
                            headerBg: '#F7F7F8',
                        },
                    },
                }}
            >
                <Table {...props} className={[props.className, styles['table-body']].join(' ')} />
            </ConfigProvider>
        </div>
    )
}

export default TableComp
